// Blog listing metadata. Full article bodies live in the BlogPost page, keyed by slug.

export const blogPosts = [
    {
      id: 15,
      title: 'The Maldives on a Real Budget: Local Islands Explained',
      excerpt: 'Guesthouses on inhabited islands put the same reefs, the same water and the same whale sharks within reach for a fraction of resort prices.',
      image: 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=1200&q=80',
      category: 'Budget Travel',
      destination: 'Maldives',
      date: 'July 22, 2026',
      readTime: '9 min read',
      slug: 'maldives-local-islands-budget',
    },
    {
      id: 16,
      title: 'Istanbul: A City on Two Continents',
      excerpt: 'Byzantine cisterns, Ottoman mosques and a ferry ride between Europe and Asia that costs less than a cup of tea.',
      image: 'https://images.unsplash.com/photo-1527838832700-5059252407fa?w=1200&q=80',
      category: 'Cultural Heritage',
      destination: 'Turkey',
      date: 'July 8, 2026',
      readTime: '10 min read',
      slug: 'istanbul-two-continents',
    },
    {
      id: 17,
      title: 'Island Hopping in Seychelles: Mahe, Praslin and La Digue',
      excerpt: 'Three islands, two ferries and a bicycle. How to see the granite archipelago without a resort budget.',
      image: 'https://images.unsplash.com/photo-1589979481223-deb893043163?w=1200&q=80',
      category: 'Adventure',
      destination: 'Seychelles',
      date: 'June 24, 2026',
      readTime: '8 min read',
      slug: 'seychelles-island-hopping',
    },
    {
      id: 18,
      title: 'Mauritius Beyond the Lagoon: Temples, Peaks and Dholl Puri',
      excerpt: 'Most visitors never leave the beach. The interior holds a sacred crater lake, seven-coloured earth and the best street food on the island.',
      image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1200&q=80',
      category: 'Cultural Heritage',
      destination: 'Mauritius',
      date: 'June 10, 2026',
      readTime: '9 min read',
      slug: 'mauritius-beyond-the-lagoon',
    },
    {
      id: 19,
      title: 'Swimming with Whale Sharks in South Ari Atoll',
      excerpt: 'The Maldives is one of the few places on earth where whale sharks appear year-round, and you meet them with a snorkel, not a tank.',
      image: 'https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=1200&q=80',
      category: 'Nature',
      destination: 'Maldives',
      date: 'May 27, 2026',
      readTime: '7 min read',
      slug: 'maldives-whale-sharks',
    },
    {
      id: 20,
      title: 'Turkey for First-Timers: A Ten-Day Route That Works',
      excerpt: 'Istanbul, Cappadocia and the turquoise coast without rushing. What to book ahead, what to skip, and what everything actually costs.',
      image: 'https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=1200&q=80',
      category: 'Adventure',
      destination: 'Turkey',
      date: 'May 12, 2026',
      readTime: '11 min read',
      slug: 'turkey-first-timer-route',
    },
    {
      id: 3,
      title: 'Sunrise at the Burj Khalifa: A Dubai Experience',
      excerpt: 'Witnessing dawn break over the desert skyline from the world\'s tallest building is an unforgettable experience.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763697731/burjkali_wj1o4a.png',
      category: 'Luxury Travel',
      destination: 'Dubai',
      date: 'October 28, 2025',
      readTime: '5 min read',
      slug: 'burj-khalifa-sunrise',
    },
    {
      id: 4,
      title: 'Tea Plantations and Mountain Trains of Sri Lanka',
      excerpt: 'Journey through emerald tea estates and colonial hill stations on one of the world\'s most scenic train rides.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763696988/beautiful-rural-tea-plantation-mountain-footage-070596380_iconl_imgupscaler.ai_General_4K_1_pr5jfc.jpg',
      category: 'Adventure',
      destination: 'Sri Lanka',
      date: 'October 20, 2025',
      readTime: '10 min read',
      slug: 'sri-lanka-tea-country',
    },
    {
      id: 5,
      title: 'Halong Bay: Vietnam\'s Natural Wonder',
      excerpt: 'Cruising through limestone karsts and emerald waters, discovering why this UNESCO site captivates millions.',
      image: 'https://images.unsplash.com/photo-1528127269322-539801943592?w=1200&q=80',
      category: 'Nature',
      destination: 'Vietnam',
      date: 'October 15, 2025',
      readTime: '7 min read',
      slug: 'halong-bay-cruise',
    },
    {
      id: 6,
      title: 'Island Hopping in Indonesia: Bali to Komodo',
      excerpt: 'From Bali\'s beaches to Komodo dragons, explore Indonesia\'s incredible island diversity.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763698368/GettyImages-156466868-57be95b53df78cc16ebc92cf_bojvap.jpg',
      category: 'Adventure',
      destination: 'Indonesia',
      date: 'October 8, 2025',
      readTime: '12 min read',
      slug: 'indonesia-island-hopping',
    },
    {
      id: 7,
      title: 'Island Temples and Jungle Bliss in Bali',
      excerpt: 'Bali is a mosaic of spiritual serenity, lush jungles, and vibrant beach life. From ancient temples perched on cliffs to rice terraces that ripple like green waves.',
      image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80',
      category: 'Cultural Heritage',
      destination: 'Indonesia',
      date: 'October 12, 2025',
      readTime: '9 min read',
      slug: 'bali-island-temples',
    },
    {
      id: 8,
      title: 'Langkawi\'s Sky Bridges and Island Magic',
      excerpt: 'Langkawi, the Jewel of Kedah, is a tropical archipelago offering a blend of adventure, relaxation, and natural beauty where emerald waters meet limestone cliffs.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763697911/skybridge-3_langkawi_1_jyvstu.jpg',
      category: 'Adventure',
      destination: 'Malaysia',
      date: 'September 18, 2025',
      readTime: '8 min read',
      slug: 'langkawi-sky-bridges',
    },
    {
      id: 9,
      title: 'Scooters, Street Food, and Scenic Bays in Vietnam',
      excerpt: 'Vietnam is a land of contrasts—chaotic cities, tranquil bays, ancient temples, and vibrant street life. From Hanoi\'s Old Quarter to the limestone karsts of Halong Bay.',
      image: 'https://images.unsplash.com/photo-1528127269322-539801943592?w=1200&q=80',
      category: 'Food & Culture',
      destination: 'Vietnam',
      date: 'August 5, 2025',
      readTime: '10 min read',
      slug: 'vietnam-scooters-bays',
    },
    {
      id: 10,
      title: 'Island Hopping and Jungle Temples of Thailand',
      excerpt: 'Thailand is a land of contrasts—bustling cities, serene beaches, and ancient temples hidden in jungles. Whether you\'re chasing sunsets or exploring golden Buddhas.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763696991/240885_64afc1d8a295f_imgupscaler.ai_V1_Fast__2K_zmkeuc.png',
      category: 'Adventure',
      destination: 'Thailand',
      date: 'October 3, 2025',
      readTime: '9 min read',
      slug: 'thailand-island-temples',
    },
    {
      id: 11,
      title: 'Laos: River Life and Ancient Mystique',
      excerpt: 'Laos is Southeast Asia\'s hidden gem—laid-back, spiritual, and rich in natural beauty. From the Mekong River to misty mountains, it\'s a place to slow down.',
      image: 'https://images.unsplash.com/photo-1540611025311-01df3cef54b5?w=1200&q=80',
      category: 'Cultural Heritage',
      destination: 'Laos',
      date: 'September 22, 2025',
      readTime: '8 min read',
      slug: 'laos-river-mystique',
    },
    {
      id: 12,
      title: 'Cambodia\'s Temples and Tonlé Sap Tales',
      excerpt: 'Cambodia is a country of resilience and wonder, where ancient temples rise from the jungle and floating villages drift across vast lakes.',
      image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?w=1200&q=80',
      category: 'Cultural Heritage',
      destination: 'Cambodia',
      date: 'August 30, 2025',
      readTime: '9 min read',
      slug: 'cambodia-temples-tonle-sap',
    },
    {
      id: 13,
      title: 'Skyscrapers and Desert Dreams in Dubai',
      excerpt: 'Dubai is a city of extremes—towering skyscrapers, golden deserts, and futuristic malls. It\'s where tradition meets innovation in dazzling style.',
      image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80',
      category: 'Luxury Travel',
      destination: 'Dubai',
      date: 'July 15, 2025',
      readTime: '7 min read',
      slug: 'dubai-desert-dreams',
    },
    {
      id: 14,
      title: 'Island Smiles and Volcano Views in the Philippines',
      excerpt: 'The Philippines is an archipelago of over 7,000 islands, each with its own charm. From white-sand beaches to emerald rice terraces, it\'s a paradise for nature lovers.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763697004/Taal_Volcano_In_The_Philippines1_imgupscaler.ai_V1_Fast__2K_fisdyn.png',
      category: 'Nature',
      destination: 'Philippines',
      date: 'June 10, 2025',
      readTime: '10 min read',
      slug: 'philippines-island-smiles',
    },
    {
      id: 2,
      title: 'A Food Lover\'s Guide to Bangkok Street Markets',
      excerpt: 'From pad thai to mango sticky rice, discover the best street food experiences in Thailand\'s vibrant capital city.',
      image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763696991/900-top-10-best-street-foods-in-vietnam__imgupscaler.ai_V1_Fast__2K_sihvbn.png',
      category: 'Food & Culture',
      destination: 'Thailand',
      date: 'November 5, 2025',
      readTime: '6 min read',
      slug: 'bangkok-street-food-guide',
    },
];

export const blogCategories = [
  'All',
  ...[...new Set(blogPosts.map((p) => p.category))].sort(),
];

